import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar shadow navbar-expand-lg">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="/img/logo.png" alt="logo" />
        </Link>
        <div
          className="collapse textColor justify-content-center navbar-collapse"
          id="main"
        >
          <ul className="navbar-nav text-center mx-auto mb-2 mb-lg-0 f-nav">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">
                <p>الرئيسية</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Page2">
                <p>اشتري</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Page3">
                <p>بيع</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Page4">
                <p>اشحن</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/deal">
                <p>اتعامل</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/learn-more">
                <p>إعرف أكتر</p>
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav text-center me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/login">
                <p>دخول إلى الحساب</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                <p>تواصل معنا</p>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
